import React from "react";
import useConfig from "../../../../../hooks/use-config";
import { SystemMessageTypes, SystemMessages } from "../systemMessages";
import { isSender } from "../../../../../utils/chat.utils";
const ICON_BASE_URL = 'https://opensooqui2.os-cdn.com/api/apiV/android/xxh';
const RichText = (props) => {
    var _a;
    const { message } = props;
    const config = useConfig();
    const lang = config.lang;
    const messageType = `${message.type}.${message.subType}`;
    if (messageType === SystemMessageTypes.ASK_FOR_VIN || messageType === SystemMessageTypes.ASK_FOR_PRICE) {
        message.text = SystemMessages[messageType].text(lang, message.sender_name, isSender(message));
        console.log(message.text, 'message.text');
    }
    else {
        message.text = SystemMessages[messageType] && ((_a = SystemMessages[messageType]) === null || _a === void 0 ? void 0 : _a.text[lang]) ? SystemMessages[messageType].text[lang] : message.text;
    }
    return (React.createElement("div", { className: 'rich-text__container' },
        React.createElement("div", { className: 'rich-text__icon-box' },
            React.createElement("img", { src: `${ICON_BASE_URL}${message.rich.icon}` })),
        React.createElement("div", { className: 'rich-text__text' }, message.text)));
};
export default RichText;
